<textarea cols="100" rows="30" [(ngModel)]="data.json" disabled></textarea>

<button class="bee-button margin-top" (click)="copyToClipboard()">Copy to clipboard</button>